module.exports = __webpack_public_path__ + "static/media/engineer.fef6ecbc.jpg";